import { twMerge } from 'tailwind-merge';

import SmFullLogoLight from '../../assets/sm-full-logo-light.png';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

export function PageHeader(props: Props) {
  return (
    <header
      className={twMerge(
        'grid',
        'grid-cols-3',
        'h-16',
        'items-center',
        'px-[30px]',
        props.className,
      )}
    >
      <div>
        <img className="h-[18px]" src={SmFullLogoLight} alt="Solana Mobile" />
      </div>
      <div className="flex items-center justify-center">
        <div className="text-white text-xl font-semibold tracking-tight whitespace-nowrap">
          Solana dApp Store
        </div>
      </div>
      <div className="flex items-center justify-end">{props.children}</div>
    </header>
  );
}
